import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from '@general/colors';
import fonts from '@general/fonts';
import { mediaQueries } from '@general/breakpoints';

const ContainerStyled = styled.div`
    align-items: center;
    background-color: ${props => props.backgroundColor};
    border-radius: 50%;
    display: flex;
    height: 32px;
    justify-content: center;
    min-width: 32px;
    width: 32px;

    @media print {
        background-color: transparent;
        border: 1px solid black;
    }

    @media ${mediaQueries.md} {
        height: 40px;
        width: 40px;
    }
`;

const TextStyled = styled.div`
    color: ${colors.white};
    font-family: ${fonts.sans};
    font-size: 16px;
    font-weight: 600;
    line-height: 21px;

    @media print {
        color: black;
        font-weight: 400;
    }
`;

const MemberInitialsWithCircle = ({ backgroundColor = colors.admiral, firstName, lastName }) => {
    return (
        <ContainerStyled backgroundColor={backgroundColor}>
            <TextStyled>
                {firstName.substring(0, 1)}
                {lastName.substring(0, 1)}
            </TextStyled>
        </ContainerStyled>
    );
};

MemberInitialsWithCircle.propTypes = {
    backgroundColor: PropTypes.string,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
};

export default MemberInitialsWithCircle;
